// @flow

import * as React from "react"
import { injectIntl } from "react-intl"
import { withRouter } from "react-router-dom"
import { autobind } from "core-decorators"
import axios from "axios"
import { notification, Button } from "antd"
import { runInAction } from "mobx"
import UiStore from "shared/stores/UiStore"
import { isProductionBuild } from "@cabonline/shared/utils/env"

type Props = {
  history: Object,
  intl: Object
}

@autobind
class AutoUpdater extends React.Component<Props> {
  shouldUpdate: boolean = false
  pollIntervalSeconds = process.env.AUTO_UPDATE_POLL_INTERVAL_SEC
    ? parseInt(process.env.AUTO_UPDATE_POLL_INTERVAL_SEC)
    : 300
  version: string = ""
  notificationKey = "autoUpdate"

  componentDidMount() {
    if (isProductionBuild) {
      this.init()
    }
  }

  async init() {
    await this.fetchVersion()
    this.props.history.listen(() => {
      if (this.shouldUpdate) {
        window.location.reload(true)
      }
    })
    setTimeout(this.poll, this.pollIntervalSeconds * 1000)
  }

  async fetchVersion() {
    try {
      const { data } = await axios.get("/version.json", {
        headers: {
          Expires: "-1",
          "Cache-Control":
            "no-cache,no-store,must-revalidate,max-age=-1,private"
        }
      })

      this.version = data.version
      runInAction(() => (UiStore.version = data.version))
    } catch (e) {
      // Do nothing, will retry on next poll.
    }
  }

  async poll() {
    const previousVersion = this.version

    await this.fetchVersion()

    if (previousVersion !== this.version) {
      this.shouldUpdate = true
      this.showUpdateNotification()
    } else {
      setTimeout(this.poll, this.pollIntervalSeconds * 1000)
    }
  }

  renderCloseButton() {
    return (
      <Button
        type="primary"
        onClick={() => {
          notification.close(this.notificationKey)
          window.location.reload(true)
        }}
      >
        {this.props.intl.formatMessage({ id: "autoUpdate.reload" })}
      </Button>
    )
  }

  showUpdateNotification() {
    notification.open({
      placement: "bottomRight",
      message: this.props.intl.formatMessage({ id: "autoUpdate.message" }),
      description: this.props.intl.formatMessage({
        id: "autoUpdate.description"
      }),
      key: this.notificationKey,
      btn: this.renderCloseButton(),
      duration: 0
    })
  }

  render() {
    return null
  }
}

export default (withRouter(injectIntl(AutoUpdater)): any)
